module.exports = __webpack_public_path__ + "img/5.3fbc2a2b.svg";